import React, { Component } from "react";
import Body from "../item/body";
import Image from "../item/image";
import Banner from "../item/banner";
import { merge, $, media, presets } from "glamor";
import ViewBase from "./base";
import MoreColors from "../item/more-colors";
import NotesIcon from "components/icons/notes";
import theme from "styles/theme";
import { themeOptions } from "styles/theme";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import Globalize from "globalize";
import CheckIcon from "@material-ui/icons/Check";
import { ItemCellSize } from "constants/types";
import { DATATEST } from "constants/integration";

const ITEM_HEIGHT = 190;
const ITEM_WIDTH = 270;
const SHADOW = 5;

const CONTAINER_HEIGHT = ITEM_HEIGHT + SHADOW * 2;
const CONTAINER_WIDTH = ITEM_WIDTH + SHADOW * 2;

const StyledTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(97, 97, 97, 0.9)",
        color: themeOptions.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: "14px",
        lineHeight: "32px",
        padding: "0 16px",
    },
}))(Tooltip);

class ItemCardView extends Component {
    static height = CONTAINER_HEIGHT;
    static width = CONTAINER_WIDTH;
    static horizontalOffset = 16 - SHADOW * 2;
    static verticalOffset = 20 - SHADOW * 2;

    static muiStyles = {
        checkbox: {
            width: "50px",
            height: "42px",
            color: themeOptions.palette.primary1Color,
        },
    };

    static styles = merge(
        {
            width: `${CONTAINER_WIDTH}px`,
            height: `${CONTAINER_HEIGHT}px`,
        },
        $(" .item", {
            display: "flex",
            height: `${ITEM_HEIGHT}px`,
            width: `${ITEM_WIDTH}px`,
        }),
        $(" .imageHolder", {
            position: "relative",
            overflow: "hidden",
            height: "100%",
            width: "82px",
            flexShrink: 0,
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
        }),
        $(" .textContent", {
            maxWidth: "192px",
            padding: "4px 6px 0px 8px",
        }),
        $(" .moreColorLabel", {
            top: "116px",
            left: "104px",
        }),
        $(" .swatches", {
            bottom: "0px",
            left: "102px",
            right: "8px",
        }),
        $(" .swatches.showAllSwatches", {
            top: "0px",
        }),
        $(" .unavailableProduct", {
            position: "absolute",
            width: `${ITEM_WIDTH}px`,
            backgroundColor: themeOptions.palette.errorBackgroundColor,
            color: themeOptions.palette.errorColor,
            height: "112px",
            top: "30px",
            padding: "16px",
            fontSize: "14px",
            left: "0px",
        }),
        $(" .unavailable", {
            opacity: "0.3",
        }),
        $(" .indicator", {
            position: "absolute",
            top: "37px",
            left: "14px",
            height: "50px",
            width: "50px",
            backgroundColor: "rgba(255, 255, 255, .8)",
            borderRadius: "4px",
            border: `1px solid ${themeOptions.palette.borderColor}`,
        }),
        media(presets.phablet, {
            width: `${ITEM_WIDTH}px`,
        })
    );

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        };
    }

    handleMouseEnter = () => {
        this.setState({ hover: true });
    };

    handleMouseLeave = () => {
        this.setState({ hover: false });
    };

    render() {
        const { item, catalogEntry, view, editable, scope, inCatalog, showActionMenu } = this.props;
        const { hover } = this.state;
        const isList = window.location.href.match("/list/");
        const linesheetAsCatalog = scope.brand.hasPreference("linesheets_are_catalogs");
        const swapOnHover = scope.brand.hasPreference("swap_product_image_on_hover");
        let containerLabel = Globalize.formatMessage("custom list");
        if (!isList) {
            containerLabel = linesheetAsCatalog
                ? Globalize.formatMessage("catalog")
                : Globalize.formatMessage("linesheet");
        }
        let notes = null;

        if (catalogEntry && (catalogEntry.notes || (editable && hover))) {
            notes = (
                <NotesIcon
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "124px",
                        width: "18px",
                        height: "22px",
                        cursor: "pointer",
                    }}
                    onClick={this.handleNotesIconClick}
                    data-test={DATATEST.CATALOG.CARD_ADD_NOTES_BTN}
                />
            );
        }

        return (
            <article onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                {this.renderBulkSelector()}
                {showActionMenu && this.productActionMenu()}
                <div className={`imageHolder ${item && item.__out_of_range ? "unavailable" : ""}`}>
                    <Image swapOnHover={swapOnHover} item={item} scope={scope} size={"T"} />
                    {inCatalog && (
                        <StyledTooltip
                            title={Globalize.formatMessage("Item already in this |container|", {
                                container: containerLabel,
                            })}
                            placement="bottom-start"
                        >
                            <div className="indicator" data-test={DATATEST.CATALOG.IN_CATALOG_INDICATOR}>
                                <CheckIcon style={ItemCardView.muiStyles.checkbox} />
                            </div>
                        </StyledTooltip>
                    )}
                    <Banner item={item} small={true} scope={scope} />
                    {item && item.hasCustomizationBanner(scope) && (
                        <Banner item={item} small={true} banner={item.getCustomizationBanner(scope)} scope={scope} />
                    )}
                    {this.props.showActions && this.renderActions(2)}
                </div>
                <div className={`textContent ${item && item.__out_of_range ? "unavailable" : ""}`}>
                    <Body
                        item={item}
                        shipStart={this.getShipStart()}
                        view={view}
                        small={true}
                        size={ItemCellSize.Card}
                        scope={scope}
                    />
                    {item && view && (
                        <MoreColors
                            item={item}
                            scope={scope}
                            onSwatchSelected={this.handleSwatchSelected}
                            small={true}
                        />
                    )}
                    {notes}
                </div>
                {item && item.__out_of_range && catalogEntry && (
                    <div className="unavailableProduct">{catalogEntry.unavailableProductWarning(scope)}</div>
                )}
            </article>
        );
    }
}

export default ViewBase(ItemCardView);
